import Flex from '@deprecated-ui/common/Flex';

import { FC, useEffect, useState } from 'react';

import If from 'global/ErrorHandlers/If';
import Image from 'global/Image';
import ModalWarning from 'global/Moderation/Modals/ModalWarning';
import { Text, Tooltip } from '@deprecated-ui/common';
import color from '@deprecated-ui/_style/color';
import { BadgeJunk, UnstyledButton } from './styled';
import { warningContent } from '../constants';

interface IWarningBadge {
  visible: boolean;
  modalReport: boolean;
  showModalReport: (value: boolean) => void;
  modalWarning: boolean;
  setModalWarning: (value: boolean) => void;
}

const WarningBadge: FC<IWarningBadge> = ({
  visible = false,
  modalReport,
  showModalReport,
  modalWarning,
  setModalWarning,
}) => (
  <If condition={visible}>
    <Tooltip
      placement="bottomRight"
      mouseLeaveDelay={0}
      mouseEnterDelay={0}
      arrowPointAtCenter
      overlayClassName="stream-label-tooltip"
      title={
        <div>
          <Flex align="center" style={{ gap: 4 }} margin="0 0 4px 0">
            <Image
              src="/images/day-trade/info-danger.svg"
              alt="Info"
              height="20"
              width="20"
            />
            <Text color={color.sunsetOrange} size="14px" weight="700">
              Content Warning
            </Text>
          </Flex>
          <Text color={color.lowgray} align="justify" size="12px" weight="400">
            {warningContent}
          </Text>
        </div>
      }
    >
      <UnstyledButton onClick={() => setModalWarning(true)}>
        <BadgeJunk type="spam" visible>
          <Image
            src="/images/day-trade/info-danger.svg"
            alt="Info"
            height="20"
            width="20"
          />
          Warning
        </BadgeJunk>
      </UnstyledButton>
    </Tooltip>
    <ModalWarning
      onSubmit={() => showModalReport(true)}
      visible={modalWarning && !modalReport}
      onCancel={() => setModalWarning(false)}
    />
  </If>
);

export default WarningBadge;
